// DECOUPLED: React skeleton CSS removed to reduce bundle
// import "react-loading-skeleton/dist/skeleton.css";
import "../scss/style.scss";
import "./app/i18n";
import { listen } from "quicklink";

// DECOUPLED: Redux and React Hydration disabled
// import { store } from "./app/store";
// import { hydrateComponents } from "./app/hydrate";

// Import Vanilla JS Header Components
import { initHeader } from "./parts/header/header";
import { initLanguageSwitcher } from "./parts/header/languageSwitcher";

// Import Vanilla JS Partials/Templates
import { initHomeContactForm } from "./partials/PageContent/homeContactForm";
import { initAccordion } from "./partials/PostContent/accordion";
import { initPageContactForm } from "./templates/contact/contactForm";

const initGlobals = () => {
  initHeader();
  initLanguageSwitcher();

  initHomeContactForm();
  initAccordion();
  initPageContactForm();

  listen();

  // DECOUPLED: React entry point disabled
  // hydrateComponents();

  console.log("[Main JS] Main JS bundle initialized (E-commerce decoupled).");
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
